import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Navigation from '@components/Nav';
import { TabContent, TabPane } from 'reactstrap';

import Plate from './Plate';
import Anchors from './Anchors';

import { setMode } from '@reducers/actions';

import './styles.scss';
import { setPanelOptions } from '@reducers/options/panel/actions';
import { setScrewOptions } from '@reducers/options/screw/actions';
import { callErrorNotification } from '@components/Notification';
import { setSquareActiveBtn, setCircleActiveBtn, setTriangleActiveBtn, setEditorActiveBtn } from '@reducers/selectors/application/actions';
import { APP_TYPES } from '@config';
import { setEditorCustomCoordinates } from '@reducers/selectors/editor/actions';
import Panel from '@scene/objects/panel';
import { APP_TEXTS } from '@texts';
import { setCustomCoordinates } from '@reducers/selectors/dimension/actions';
import { mergeDeep, getCenterOfPoints } from '@services/helper.service';
import { setBeamShiftY, setBeamShiftX } from '@reducers/options/beam/actions';

const editorTabs = {
  PLATE: 'plate',
  ANCHORS: 'anchors'
};

// const NAVIGATION = [
//   {
//     key: editorTabs.PLATE,
//     value: 'Plate'
//   },
//   {
//     key: editorTabs.ANCHORS,
//     value: 'Anchors'
//   }
// ];

class Editor extends Component {
  
  static propTypes = {
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      editorState: {},
      activeTab: editorTabs.PLATE
    };
  }

  componentDidMount() {
    this.setState({
      objectState: JSON.parse(JSON.stringify(this.props.objectState))
    });
  }

  render() {
    return (
      <div className="editor">
        <div className="sticky-header">
          <Navigation tabs={editorTabs} activeTab={this.state.activeTab} toggle={this.toggle} />
        </div>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId={editorTabs.PLATE}>
            <Plate />
          </TabPane>
          <TabPane tabId={editorTabs.ANCHORS}>
            <Anchors />
          </TabPane>
        </TabContent>

        <div className="d-flex fle mt-2">
          <button className="w-25" onClick={() => {
              this.props.onSave(this.props.prevMode, this.props.objectState);
              if (this.props.specifyCoordinates)
                this.props.setCustomCoordinates(false);
            }}>
            {APP_TEXTS.ANCHOR_SELECTION_OK.Content}
          </button>

          <button className="w-25" onClick={() => this.props.onCancel(this.props.prevMode, this.state.objectState)}>
            {APP_TEXTS.BUTTONS_CANCEL.Content}
          </button>
        </div>
      </div>
    );
  }

  toggle = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  };
  
}

const mapState = state => ({
  prevMode: state.main.prevMode,
  objectState: {
    screw: mergeDeep({}, state.options.screw, { outside: [] }), // VladP: unable to serialize the screws' mesh
    panel: state.options.panel,
    activeSquareBtn: state.selectors.application[APP_TYPES.GENERAL_CALCULATION].activeSquareBtn,
    activeCircleBtn: state.selectors.application[APP_TYPES.GENERAL_CALCULATION].activeCircleBtn,
    activeTriangleBtn: state.selectors.application[APP_TYPES.GENERAL_CALCULATION].activeTriangleBtn,
    beamShift: state.selectors.dimension[APP_TYPES.GENERAL_CALCULATION].axisPosition
  },
  specifyCoordinates: (state.selectors.dimension[state.main.appType].basePlate && 
    state.selectors.dimension[state.main.appType].basePlate.spacing && 
    state.selectors.dimension[state.main.appType].basePlate.spacing.specifyCoordinates) || false
});

const mapDispatch = dispatch => ({
  onSave: (prevMode, currentState) => {
    if (validate(currentState)) {
      dispatch(setMode(prevMode));
      dispatch(setEditorActiveBtn(true));
      dispatch(setEditorCustomCoordinates(
        currentState.panel.vertices.positions.map((screw) => { return { x: screw.y * -1, y: screw.z }; }),
        currentState.screw.coordinatesList.map((screw) => { return { x: screw.y * -1, y: screw.z * -1}; })
      ));
      var center = getCenterOfPoints(currentState.panel.vertices.positions);
      // VladP: Need to make sure that the panel type is custom
      dispatch(setPanelOptions({
        type: Panel.types.CUSTOM,
        // vertices: {
        //   count: 0,//currentState.panel.vertices.positions.length,
        //   positions: currentState.panel.vertices.positions
        // }
        center: {
          x: center.y,
          y: center.z
        }
      }));
      
      var oldCenter = {
        x: currentState.panel.center && currentState.panel.center.x || 0,
        y: currentState.panel.center && currentState.panel.center.y || 0
      };
      dispatch(setBeamShiftX(center.y + (currentState.beamShift.ex - oldCenter.x)));
      dispatch(setBeamShiftY((-center.z + (currentState.beamShift.ey + oldCenter.y))));
    } else {
      if (!currentState.panel.vertices.isConvex) {
        callErrorNotification(APP_TEXTS.NOTIFICATION_ERROR_PLATE_SHAPE.Content);
      }

      if (currentState.screw.outside.state) {
        callErrorNotification(APP_TEXTS.NOTIFICATION_ERROR_SCREWS.Content);
      }
    }
  },
  onCancel: (prevMode, objectState) => {
    dispatch(setMode(prevMode));

    dispatch(setPanelOptions(objectState.panel));
    dispatch(setScrewOptions(objectState.screw));

    if (objectState.activeSquareBtn)
      dispatch(setSquareActiveBtn(objectState.activeSquareBtn));
    else if (objectState.activeCircleBtn)
      dispatch(setCircleActiveBtn(objectState.activeCircleBtn));
    else if (objectState.activeTriangleBtn)
      dispatch(setTriangleActiveBtn(objectState.activeTriangleBtn));
  },
  setCustomCoordinates: (value) => dispatch(setCustomCoordinates(value))
});

export default connect(
  mapState,
  mapDispatch
)(Editor);

function validate(state) {
  return state.panel.vertices.isConvex && !state.screw.outside.state;
}



// WEBPACK FOOTER //
// ./src/components/Editor/index.js